export default __webpack_public_path__ + "static/media/logoFond.38de4572.jpg";